import { isRouteErrorResponse, useRouteError } from 'react-router';
import { useFormatMessage } from '~/intl';

import { BaseError } from '../base-error';

export function RootErrorBoundary() {
  const error = useRouteError();
  const formatMessage = useFormatMessage();

  if (isRouteErrorResponse(error)) {
    return <BaseError message={error.statusText} stack={error.data} title={error.status.toString()} />;
  }

  if (error instanceof Error) {
    return <BaseError stack={error?.stack} title={error.message} />;
  }

  return <BaseError title={formatMessage({ id: 'error.DEFAULT' })} />;
}
